var exports = {
  "kL": "x2b2fbebb--ded951--container",
  "DD": "x2b2fbebb--ded951--title",
  "VA": "x2b2fbebb--ded951--subtitle",
  "x6": "x2b2fbebb--ded951--button",
};

module.exports = exports;
